var map = {
	"./icon-3dots.svg": "JYXE",
	"./icon-C++.svg": "F6eJ",
	"./icon-C.svg": "2cox",
	"./icon-aimate-account.svg": "39Ol",
	"./icon-aimate-alert.svg": "d7fk",
	"./icon-aimate-coin.svg": "6gor",
	"./icon-aimate-credit-card.svg": "T3pr",
	"./icon-aimate-free.svg": "vk1D",
	"./icon-aimate-logout.svg": "vVE2",
	"./icon-aimate-notification.svg": "cX8R",
	"./icon-aimate-plan.svg": "/aL4",
	"./icon-aimate-pro.svg": "wOGK",
	"./icon-aimate-setting.svg": "wdvI",
	"./icon-aimate-starter.svg": "V4c/",
	"./icon-aimate-warning.svg": "WPSU",
	"./icon-alert-active.svg": "lhYH",
	"./icon-alert-exclamation-white.svg": "Q4se",
	"./icon-alert-exclamation.svg": "2TvE",
	"./icon-alert-normal.svg": "lu0M",
	"./icon-answer-record-active.svg": "xox7",
	"./icon-answer-record.svg": "EmIa",
	"./icon-arrow-down-with-tail-inactive.svg": "asWQ",
	"./icon-arrow-down-with-tail.svg": "8xL+",
	"./icon-arrow-down.svg": "ECsX",
	"./icon-arrow-left.svg": "mrY4",
	"./icon-arrow-right.svg": "n4XH",
	"./icon-arrow-up-with-tail-inactive.svg": "Cxro",
	"./icon-arrow-up-with-tail.svg": "joYb",
	"./icon-arrow-up.svg": "+psr",
	"./icon-article.svg": "s7B3",
	"./icon-back-border-dark.svg": "yL9q",
	"./icon-back-dark.svg": "Tg7L",
	"./icon-back.svg": "cFL0",
	"./icon-boldcheck-active.svg": "E11q",
	"./icon-boldcheck-normal.svg": "Qr6Z",
	"./icon-bow-active.svg": "FVix",
	"./icon-bow-normal.svg": "nAYa",
	"./icon-bubble-video.svg": "XfVx",
	"./icon-calendar-white.svg": "mrcH",
	"./icon-cancel-hover.svg": "0339",
	"./icon-cancel-normal.svg": "ytIs",
	"./icon-cancel-r-hover.svg": "8/63",
	"./icon-cancel-r-normal.svg": "cOL1",
	"./icon-cart-active.svg": "z6MQ",
	"./icon-cart.svg": "vg4b",
	"./icon-chat-active-click.svg": "T2O9",
	"./icon-chat-active.svg": "6j1i",
	"./icon-checkbox-checked.svg": "gSLi",
	"./icon-checkbox-disabled.svg": "kzjS",
	"./icon-checkbox-partial.svg": "AWwV",
	"./icon-cir-active.svg": "4cCT",
	"./icon-cir-check-highlighted.svg": "MtZe",
	"./icon-cir-check-unhighlighted.svg": "9c28",
	"./icon-cir-normal.svg": "SLND",
	"./icon-circle-gray.svg": "VmCs",
	"./icon-circle-yellow.svg": "D1MX",
	"./icon-clear.svg": "tAX1",
	"./icon-close-dark.svg": "Ui2Y",
	"./icon-close-light.svg": "BFYz",
	"./icon-close-white.svg": "Nfj9",
	"./icon-close.svg": "LuXR",
	"./icon-code.svg": "wMW9",
	"./icon-codetype-c.svg": "hnRc",
	"./icon-codetype-cpp.svg": "j0fu",
	"./icon-codetype-lua.svg": "UCKj",
	"./icon-codetype-meowbit.svg": "ZLy7",
	"./icon-codetype-microbit.svg": "ufS1",
	"./icon-codetype-pygame.svg": "YUJU",
	"./icon-codetype-python.svg": "i0OB",
	"./icon-codetype-pyweb.svg": "f088",
	"./icon-codetype-video.svg": "gb9X",
	"./icon-coming-soon.svg": "te6Q",
	"./icon-copy.svg": "25xr",
	"./icon-correct-active.svg": "NKAr",
	"./icon-course-active.svg": "onOE",
	"./icon-course.svg": "eGtB",
	"./icon-courses-active.svg": "Yy8a",
	"./icon-courses-normal.svg": "OWga",
	"./icon-delete.svg": "DBWx",
	"./icon-diamond-active.svg": "C2X/",
	"./icon-diamond-normal.svg": "nZKu",
	"./icon-doctype-avi.svg": "tI67",
	"./icon-doctype-doc.svg": "QHZM",
	"./icon-doctype-info.svg": "Gr7V",
	"./icon-doctype-jpg.svg": "671d",
	"./icon-doctype-mp3.svg": "DmRR",
	"./icon-doctype-pdf.svg": "HBsQ",
	"./icon-doctype-png.svg": "bSdI",
	"./icon-doctype-ppt.svg": "NCb/",
	"./icon-doctype-txt.svg": "o9ZF",
	"./icon-doctype-xls.svg": "V6Et",
	"./icon-done.svg": "kCzV",
	"./icon-download-active.svg": "Sh/s",
	"./icon-download-arrow-white.svg": "zwJP",
	"./icon-download-arrow.svg": "gTzv",
	"./icon-download-hover.svg": "siaN",
	"./icon-download-normal.svg": "+/MF",
	"./icon-download.svg": "7eSt",
	"./icon-dropdown-24.svg": "OCMT",
	"./icon-dropup-24.svg": "5R97",
	"./icon-error.svg": "Cu+t",
	"./icon-exercise-answers.svg": "gZ2L",
	"./icon-exercise-content.svg": "3aty",
	"./icon-exercise-folder-active.svg": "0g+0",
	"./icon-exercise-folder.svg": "hDKo",
	"./icon-exercise-materials.svg": "2u7P",
	"./icon-exercise-tips.svg": "B21R",
	"./icon-film.svg": "jU3c",
	"./icon-finished.svg": "Dc+7",
	"./icon-freecode.svg": "F7Uz",
	"./icon-fullscreen-white.svg": "1rlB",
	"./icon-fullscreen.svg": "wQJy",
	"./icon-goodjob-active.svg": "5ltb",
	"./icon-goodjob-normal.svg": "xVoQ",
	"./icon-greencheck-active.svg": "i2ms",
	"./icon-greencheck-normal.svg": "x6DZ",
	"./icon-hamburger-menu.svg": "bwBW",
	"./icon-heart-active.svg": "ixzx",
	"./icon-heart-normal.svg": "Bz2u",
	"./icon-hint.svg": "8lf/",
	"./icon-honor-active.svg": "hNXq",
	"./icon-honor.svg": "bUBG",
	"./icon-index-gray_down.svg": "fyEf",
	"./icon-index_down.svg": "CBbg",
	"./icon-index_up.svg": "HWle",
	"./icon-info-black.svg": "4WPo",
	"./icon-info-white.svg": "Dm/5",
	"./icon-java.svg": "Fr6E",
	"./icon-lesson-active.svg": "K4Jt",
	"./icon-lesson-question.svg": "pld1",
	"./icon-lesson.svg": "pueQ",
	"./icon-library-active.svg": "Tl/a",
	"./icon-library.svg": "Yj9p",
	"./icon-line.svg": "xB6O",
	"./icon-list-active-click.svg": "eUL8",
	"./icon-list-active.svg": "D/nO",
	"./icon-list-darkmode-active-click.svg": "I0HE",
	"./icon-list-darkmode-active.svg": "BkUs",
	"./icon-live_class-active.svg": "kNfv",
	"./icon-live_class.svg": "NCc0",
	"./icon-lock-grey.svg": "fY9U",
	"./icon-logout.svg": "/eAR",
	"./icon-mark-active.svg": "PdmG",
	"./icon-mark-normal.svg": "n5Sa",
	"./icon-material.svg": "jTSs",
	"./icon-materials-active.svg": "tC+R",
	"./icon-materials-inactive.svg": "XkXt",
	"./icon-mbit.svg": "8CEu",
	"./icon-menu.svg": "MaPv",
	"./icon-meowbit.svg": "CucT",
	"./icon-messenger-active.svg": "y+sj",
	"./icon-messenger.svg": "QYwO",
	"./icon-noData.svg": "nyuT",
	"./icon-note-active-click.svg": "H0xS",
	"./icon-note-active.svg": "e8Il",
	"./icon-note.svg": "LrLt",
	"./icon-notes.svg": "sIDf",
	"./icon-notification.svg": "Isxn",
	"./icon-notify-activity.svg": "yHNQ",
	"./icon-notify-challenge.svg": "23aP",
	"./icon-notify-cheerup.svg": "o/SD",
	"./icon-notify-homework.svg": "BEHM",
	"./icon-notify-newinfo.svg": "529T",
	"./icon-pin-gray.svg": "37V/",
	"./icon-pin-yellow.svg": "EcLZ",
	"./icon-plus-white.svg": "DdhB",
	"./icon-prac-active-click.svg": "Q32M",
	"./icon-prac-active.svg": "Ven8",
	"./icon-prac-darkmode-active-click.svg": "R+WD",
	"./icon-prac-darkmode-active.svg": "HkX7",
	"./icon-prac.svg": "EVwq",
	"./icon-premium-label.svg": "gVwc",
	"./icon-py.svg": "qTWw",
	"./icon-pygame.svg": "haxK",
	"./icon-pyweb.svg": "PwR5",
	"./icon-quarter-active.svg": "nKVF",
	"./icon-quarter-normal.svg": "CtNR",
	"./icon-question-square.svg": "K7XZ",
	"./icon-refresh-white.svg": "mgLQ",
	"./icon-refresh.svg": "1KkL",
	"./icon-result-active.svg": "+Mr+",
	"./icon-result-normal.svg": "Lg12",
	"./icon-run-outline.svg": "621g",
	"./icon-run-yellow.svg": "Msr0",
	"./icon-run.svg": "o5Ey",
	"./icon-search-24.svg": "Ey2o",
	"./icon-search-32.svg": "Dh6M",
	"./icon-search-black.svg": "QGix",
	"./icon-setting-active-click.svg": "8koq",
	"./icon-setting-active.svg": "LKd9",
	"./icon-setting-darkmode-active-click.svg": "iGfo",
	"./icon-setting-darkmode-active.svg": "/eyA",
	"./icon-setting-white.svg": "OHg4",
	"./icon-setting.svg": "R9AN",
	"./icon-slash-active.svg": "3XkP",
	"./icon-slash-normal.svg": "7/1I",
	"./icon-spades-active.svg": "O4yl",
	"./icon-spades-normal.svg": "crbx",
	"./icon-square-active.svg": "EKYo",
	"./icon-square-normal.svg": "OpfG",
	"./icon-star-active.svg": "ZJse",
	"./icon-star-hover.svg": "mrjI",
	"./icon-star-normal.svg": "8ZnC",
	"./icon-status-done-blue-24.svg": "UBxw",
	"./icon-stop.svg": "rdA9",
	"./icon-student-status-done.svg": "XRDn",
	"./icon-student-status-goodjob.svg": "pl4+",
	"./icon-student-status-help.svg": "tk/k",
	"./icon-student-status-leave.svg": "U2BZ",
	"./icon-student-status-star.svg": "AIMS",
	"./icon-student-status-warnning.svg": "7M94",
	"./icon-student-white.svg": "0RzY",
	"./icon-student.svg": "wV0z",
	"./icon-student_manage-active.svg": "koJY",
	"./icon-student_manage.svg": "oThY",
	"./icon-submit-outline.svg": "+vAw",
	"./icon-submit-success-yellow.svg": "xkpj",
	"./icon-teacher_manage-active.svg": "jFOz",
	"./icon-teacher_manage.svg": "pCjG",
	"./icon-test-active.svg": "XBkE",
	"./icon-test.svg": "H3n0",
	"./icon-time.svg": "0RjY",
	"./icon-tips-active.svg": "JGjz",
	"./icon-tips-inactive.svg": "ejYd",
	"./icon-tri-active.svg": "72yl",
	"./icon-tri-normal.svg": "JGzo",
	"./icon-unfinished.svg": "HRpe",
	"./icon-union.svg": "3+6z",
	"./icon-unpin-yellow.svg": "sZ7q",
	"./icon-upload.svg": "JG+4",
	"./icon-user-active.svg": "fArK",
	"./icon-user.svg": "FpyW",
	"./icon-video.svg": "Vk6A",
	"./icon-white-checked.svg": "G5yx",
	"./icon-wrong-active.svg": "ATwe",
	"./icon-wrong-answer.svg": "Cc2O",
	"./icon-zoom.svg": "rO2f",
	"./icon-zoomlive.svg": "jmGd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CW9L";